import {MODAL_DEACTIVATED} from '../constants/modal';

export const modalDeactivated = () => {
	return {
		type: MODAL_DEACTIVATED,
		payload: {}
	};
};